import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";

import {
  Header, Screen1, Useful, Why, Pill, About, TextReviews, VideoReviewsWithCards, Speaker, Extra, Partners, Form,
  MetaPixel
} from "../../../components/LandingTemplates/krp";
import { FooterMedium } from "../../../components/FooterMedium";

import headerNav from "../../../components/LandingTemplates/krp/data/_molodostmozga/headerNav.json";
import dataAZ from "../../../components/LandingTemplates/krp/data/_molodostmozga/dataAZ.json";

const TITLE = 'Как омолодить мозг на 20 лет и начать вторую молодость';
const DESCRIPTION = 'Как омолодить мозг на 20 лет и начать вторую молодость | Центр образовательных технологий Advance ✅ Уникальные методики обучения ☝️ Заходите!';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION} gcCounter={true}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>

    <YandexMetrika />
    <MetaPixel />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <Header data={headerNav} />

    <main>
      <Screen1 />
      <Useful />
      <Why />
      <Pill />
      <About />
      <VideoReviewsWithCards />
      <TextReviews />
      <Speaker
        title={"Ведущий"}
        speakerName={"Александр Згода"}
        speakerProf={"Генеральный и академический директор Advance"}
        speakerPhoto={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/az-big.png"}
        dataProfList={dataAZ}
        iconColor={'#FD4B04'}
      />
      <Extra />
      <Partners />
      <Form widget={
        <GetCourseWidget hash={'767de6ebdac32613a0eb4b88a06cedd3d8d056ab'} id={'880399'} />
      }/>
    </main>

    <FooterMedium />

  </DefaultLayout>
);

export default Page;
